import { ShieldAlert } from 'lucide-react';

import { Button } from '@/components/ui/button/button';

interface EnabledContentOTPProps {
  onEnable2FA: () => void;
  onLogout: () => void;
  isLoggingOut?: boolean;
}

export const EnabledContentOTP = ({
  onEnable2FA,
  onLogout,
  isLoggingOut = false,
}: EnabledContentOTPProps) => {
  return (
    <div className="pb-6">
      <div className="grid min-h-full place-items-center rounded-xl border bg-white px-6 py-24 sm:py-10 lg:px-8">
        <div className="w-full max-w-3xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-3 py-1 text-xs font-medium text-red-700">
            <ShieldAlert className="h-4 w-4" />
            Security Required
          </div>

          <h3 className="mt-5 text-3xl font-medium tracking-tight text-gray-900 sm:text-5xl">
            Enable Two-Factor Authentication
          </h3>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 font-light text-gray-600 sm:text-lg">
            For account security, 2FA must be enabled before you can continue using other dashboard
            features.
          </p>

          <div className="mx-auto my-6 grid max-w-2xl gap-3 text-left sm:grid-cols-2">
            <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
              <p className="font-semibold text-gray-900">Why this is required</p>
              <p className="mt-1 leading-6">
                2FA adds an extra verification layer during sign-in and helps prevent unauthorized
                access.
              </p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
              <p className="font-semibold text-gray-900">What you can do now</p>
              <p className="mt-1 leading-6">
                Open the setup popup to enable 2FA, or logout first and continue later.
              </p>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button
              className="bg-brand-blue hover:bg-brand-blue/90 w-full sm:w-auto"
              onClick={onEnable2FA}
            >
              Enable 2FA
            </Button>

            <Button
              variant="outline"
              className="w-full sm:w-auto"
              onClick={onLogout}
              disabled={isLoggingOut}
            >
              {isLoggingOut ? 'Logging out...' : 'Logout'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
